import create from 'zustand'

const useStore = create((set, get) => ({
  serverTime: null,
  setServerTime: time => set({ serverTime: time }),
}))
export default useStore
